import { render } from "./MasazaSp.vue?vue&type=template&id=b320872a&scoped=true"
import script from "./MasazaSp.vue?vue&type=script&lang=js"
export * from "./MasazaSp.vue?vue&type=script&lang=js"

import "./MasazaSp.vue?vue&type=style&index=0&id=b320872a&scoped=true&lang=css"
import "./MasazaSp.vue?vue&type=style&index=1&id=b320872a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b320872a"]])

export default __exports__